jQuery(document).ready(function($){
	let sliders = $('.slider');
	sliders.each(function(){
		let slider = new Slider($(this));
	})
})
Slider.breakPoint = 782;
Slider.colClassDeskPrefix = 'col-desk-';
Slider.colClassMobPrefix = 'col-mob-';
Slider.delay = 8000;
function Slider(DOMTarget){
	this.DOMTarget = DOMTarget;
	this.numberMob = 3;
	this.numberDesk = 1;
	this.slider = false;
	this.sliderIsRunning = false;
	this.effect = 'slide';
	this.shadow = false;
	this.rotate = 50;
	this.spacing = 30;
	this.spacing_mobile = 40;
	this.delay = 4000;
	this.speed = 300;
	this.loop = false;

	this.createSlider = function(){
		let instance = this;
		if(!instance.sliderIsRunning){
			instance.DOMTarget.addClass('slider-active');
			let params = {
				slidesPerView: 1,
				navigation: {
					nextEl: '.button-next',
					prevEl: '.button-prev',
				},
				pagination: {
					el: '.dots',
					clickable: true,
				},
				grabCursor: true,
				breakpoints: {},
				speed: instance.speed===0 ? 400 : instance.speed,
			}

			//SLIDE RESPONSIVE
			params.slidesPerView = instance.numberMob==="auto" ? "auto" : parseInt(instance.numberMob);
			params.spaceBetween= parseInt(instance.spacing_mobile);
			params.breakpoints[Slider.breakPoint] = {
				spaceBetween: instance.spacing,
				slidesPerView: parseInt(instance.numberDesk)
			}

			//EFFECT
			params.effect = instance.effect;
			let effectParams = {
				slideShadows: false,
			}
			if(instance.effect==="coverflow") effectParams.rotate = instance.rotate;
			if(instance.effect==="cube") effectParams.shadow = instance.shadow;
			params[instance.effect+'Effect'] = effectParams;
			//AUTOPLAY & DELAY
			if(instance.delay+instance.speed>0){
				params.autoplay = {
					disableOnInteraction: false,
					delay: instance.delay
				}
			}
			if(instance.delay===0) instance.DOMTarget.find('.swiper-wrapper').addClass('linear-wrapper');

			if(instance.loop) params.loop = true;

			instance.slider = new Swiper(instance.DOMTarget[0], params);

			if(instance.DOMTarget.parent().parent().hasClass('ic-blocks-post-list-container') && instance.DOMTarget.parent().parent().hasClass('is-style-with-menu')){
				instance.DOMTarget.parent().parent().find('>.menu-post-list>ul>li').each(function(index, item){
					jQuery(item).click(function(){instance.slider.slideTo(index+1)});
				})
			}
			instance.sliderIsRunning = true;
		}
	}
	this.destroySlider = function(){
		if(this.sliderIsRunning){
			this.slider.destroy(true, true);
			this.DOMTarget.find('.dots>*').remove();
			this.DOMTarget.removeClass('slider-active');
			this.sliderIsRunning = false;
		}
	}

	this.resize = function(){
		let instance = this;
		if(jQuery(window).width()>Slider.breakPoint) {
			instance.DOMTarget.removeClass(Slider.colClassMobPrefix+instance.numberMob);
			instance.DOMTarget.addClass(Slider.colClassDeskPrefix +instance.numberDesk);
			if(instance.DOMTarget.hasClass('on-desktop') && !instance.DOMTarget.hasClass('no-support-adaptation') && !instance.sliderIsRunning){
				if(!instance.sliderIsRunning) instance.DOMTarget.find('.swiper-wrapper').css('gap', "");
				instance.createSlider();
			}else{
				if(!instance.DOMTarget.hasClass('on-desktop')) instance.destroySlider();
				if(!instance.sliderIsRunning) instance.DOMTarget.find('.swiper-wrapper').css('gap', instance.spacing);
			}
		}else{
			instance.DOMTarget.addClass(Slider.colClassMobPrefix+instance.numberMob);
			instance.DOMTarget.removeClass(Slider.colClassDeskPrefix +instance.numberDesk);
			if(instance.DOMTarget.hasClass('on-mobile') && !instance.DOMTarget.hasClass('no-support-adaptation') && !instance.sliderIsRunning){
				if(!instance.sliderIsRunning) instance.DOMTarget.find('.swiper-wrapper').css('gap', "");
				instance.createSlider();
			}else{
				if(!instance.DOMTarget.hasClass('on-mobile')) instance.destroySlider();
				if(!instance.sliderIsRunning) instance.DOMTarget.find('.swiper-wrapper').css('gap', instance.spacing_mobile);
			}
		}
	}
	this.build = function(){
		let instance = this;
		if(!instance.DOMTarget.hasClass('on-mobile') && !instance.DOMTarget.hasClass('on-desktop')) instance.DOMTarget.addClass('on-mobile');
		if(!instance.DOMTarget.find('.swiper-wrapper').length && instance.DOMTarget.find('ul').length){
			instance.DOMTarget.find('ul').first().addClass('swiper-wrapper');
		}
		if(!instance.DOMTarget.find('.swiper-wrapper').length && instance.DOMTarget.find('>.wp-block-group__inner-container').length){
			instance.DOMTarget.find('>.wp-block-group__inner-container').addClass('swiper-wrapper');
		}
		if(!instance.DOMTarget.find('.swiper-slide').length && instance.DOMTarget.find('>.wp-block-group__inner-container.swiper-wrapper').length) instance.DOMTarget.find('>.wp-block-group__inner-container.swiper-wrapper>*').addClass('swiper-slide');
		if(!instance.DOMTarget.find('.swiper-slide').length && instance.DOMTarget.find('ul.swiper-wrapper').length) instance.DOMTarget.find('ul.swiper-wrapper li').addClass('swiper-slide');
		if(!instance.DOMTarget.find('.swiper-slide').length) instance.DOMTarget.find('.swiper-wrapper>*:not(.full-item)').addClass('swiper-slide');
		if(!instance.DOMTarget.find('.dots').length){
			instance.DOMTarget.append(
				jQuery('<div/>').addClass('dots')
			);
		}
		if(!instance.DOMTarget.find('.button-prev').length){
			instance.DOMTarget.append(
				jQuery('<div/>').addClass('button-prev')
			);
		}
		if(!instance.DOMTarget.find('.button-next').length){
			instance.DOMTarget.append(
				jQuery('<div/>').addClass('button-next')
			);
		}
		if(instance.DOMTarget.attr('data-delay') || instance.DOMTarget.attr('data-speed')){
			let attrDelay = instance.DOMTarget.attr('data-delay') ? parseInt(instance.DOMTarget.attr('data-delay')) : 0;
			let attrSpeed = instance.DOMTarget.attr('data-speed') ? parseInt(instance.DOMTarget.attr('data-speed')) : 0;
			instance.speed = attrSpeed;
			instance.delay = attrDelay;
		}
		if(instance.DOMTarget.attr('data-spacing-desktop')){
			if(parseInt(instance.DOMTarget.attr('data-spacing-desktop'))) instance.spacing = parseInt(instance.DOMTarget.attr('data-spacing-desktop'))
			else instance.spacing = 0;
		}
		if(instance.DOMTarget.data('spacing-mobile')){
			instance.spacing_mobile = parseInt(instance.DOMTarget.data('spacing-mobile'));
		}

		if(instance.DOMTarget.data('effect')){
			instance.effect = instance.DOMTarget.data('effect');
		}
		if(instance.DOMTarget.data('shadow')){
			instance.shadow = true;
		}
		if(instance.DOMTarget.data('rotate')){
			instance.rotate = parseInt(instance.DOMTarget.data('rotate'));
		}
		instance.loop = instance.DOMTarget.data('loop');

		let classContainer = instance.DOMTarget[0].classList;
		classContainer.forEach(function(item){
			if(item.startsWith(Slider.colClassMobPrefix)){
				instance.numberMob = parseInt(item.substr(Slider.colClassMobPrefix.length));
			}
			if(item.startsWith(Slider.colClassDeskPrefix)){
				instance.numberDesk = parseInt(item.substr(Slider.colClassDeskPrefix .length));
			}
		});
		instance.DOMTarget.removeClass(Slider.colClassMobPrefix+instance.numberMob);
		instance.DOMTarget.removeClass(Slider.colClassDeskPrefix +instance.numberDesk);
		if(instance.effect!=='slide'){
			if(instance.DOMTarget.hasClass('on-desktop')) instance.numberDesk = 1;
			if(instance.DOMTarget.hasClass('on-mobile')) instance.numberMob = 1;
		}
		if(instance.effect==="cube") instance.spacing=0;

		jQuery(window).resize(function(){
			instance.resize();
		})
		instance.resize();
	}
	this.getSlider = function(){
		return this.slider;
	}

	if(!(this instanceof Slider)){
		return new Slider(DOMTarget);
	}
	this.build();
}
window.Slider = Slider;
